module.exports = __webpack_public_path__ + "img/city&terminal-save.e64e0580.svg";